import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/_modules/material.module';
import { SharedModule } from 'src/app/_components/shared.module';
import { WelcomeComponent } from './welcome.component';
import { BarcodeScannerComponent } from './barcode-scanner/barcode-scanner.component';
import { FlightLookupFormComponent } from './flight-lookup-form/flight-lookup-form.component';
import { FlightSearchFormComponent } from './flight-search-form/flight-search-form.component';
import { HeroComponent } from './hero/hero.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { LanguageResolver } from 'src/app/_resolvers/language/language.resolver';
import { AuthGuard } from 'src/app/_guards/auth/auth.guard';
import { WelcomeGuard } from './_guards/welcome.guard';
import { AirportsResolver } from './_resolvers/airports.resolver';
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { TextMaskModule } from "angular2-text-mask";
import { TrhNavigationComponent } from '../prechat/trh-navigation/trh-navigation.component';

@NgModule({
  declarations: [
    WelcomeComponent,
    BarcodeScannerComponent,
    FlightLookupFormComponent,
    FlightSearchFormComponent,
    HeroComponent,
    TooltipComponent,
    // TrhNavigationComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      { 
        path: '',
        component: WelcomeComponent,
        canActivate: [AuthGuard,WelcomeGuard],
        resolve:[LanguageResolver,AirportsResolver]
      }
    ]),
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    TextMaskModule,
    AutocompleteLibModule,
  ]
})
export class WelcomeModule {
}
